import { Stack } from '@mui/material';
import { FC } from 'react';
import { Control, Title } from './components';
import useGradesLoading from './use-grades-loading';
import GradeFiltersPanel from './GradeFiltersPanel';

const GradeFiltersControl: FC = () => {
    const { handleReferenceClick } = useGradesLoading();

    return (
        <Control>
            <Stack>
                <Title />
                <GradeFiltersPanel onSelect={handleReferenceClick} />
            </Stack>
        </Control>
    );
};

export default GradeFiltersControl;
